import React from "react";
import type { ISvgProps } from "components/icons/shared_props";

import { MAIN_THEME } from "styles/theme";

export default function SettingsIcon({
  size = MAIN_THEME.iconSize.small,
  color = MAIN_THEME.colors.brandGray30,
}: ISvgProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      preserveAspectRatio="xMidYMid meet"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}>
      <path fill="none" d="M0 0h24v24H0z" />
      <path
        fill={color}
        d="M17 4.999H7c-3.86 0-7 3.14-7 7 0 3.861 3.14 7 7 7h10c3.86 0 7-3.139 7-7 0-3.86-3.14-7-7-7zm0 10a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"
      />
    </svg>
  );
}
